/* tslint:disable */
/* eslint-disable */
/**
 * Microtech partes API
 * API Library for SmartyBar application
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * AuthEnAreaWebAppApi - axios parameter creator
 * @export
 */
export const AuthEnAreaWebAppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Set a new password
         * @param {string} token The token send by email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authEstablecerPasswordTokenPost: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling authEstablecerPasswordTokenPost.');
            }
            const localVarPath = `/auth/establecer-password/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request reset password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authReestablecerPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/reestablecer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login in WebApp area
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthEnAreaWebAppApi - functional programming interface
 * @export
 */
export const AuthEnAreaWebAppApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Set a new password
         * @param {string} token The token send by email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authEstablecerPasswordTokenPost(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await AuthEnAreaWebAppApiAxiosParamCreator(configuration).authEstablecerPasswordTokenPost(token, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
        /**
         * 
         * @summary Request reset password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authReestablecerPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await AuthEnAreaWebAppApiAxiosParamCreator(configuration).authReestablecerPost(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
        /**
         * 
         * @summary Login in WebApp area
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await AuthEnAreaWebAppApiAxiosParamCreator(configuration).loginPost(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
    }
};

/**
 * AuthEnAreaWebAppApi - factory interface
 * @export
 */
export const AuthEnAreaWebAppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Set a new password
         * @param {string} token The token send by email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authEstablecerPasswordTokenPost(token: string, options?: AxiosRequestConfig): Promise<any> {
            return AuthEnAreaWebAppApiFp(configuration).authEstablecerPasswordTokenPost(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request reset password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authReestablecerPost(options?: AxiosRequestConfig): Promise<any> {
            return AuthEnAreaWebAppApiFp(configuration).authReestablecerPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login in WebApp area
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginPost(options?: AxiosRequestConfig): Promise<any> {
            return AuthEnAreaWebAppApiFp(configuration).loginPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthEnAreaWebAppApi - object-oriented interface
 * @export
 * @class AuthEnAreaWebAppApi
 * @extends {BaseAPI}
 */
export class AuthEnAreaWebAppApi extends BaseAPI {
    /**
     * 
     * @summary Set a new password
     * @param {string} token The token send by email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthEnAreaWebAppApi
     */
    public async authEstablecerPasswordTokenPost(token: string, options?: AxiosRequestConfig) : Promise<any> {
        return AuthEnAreaWebAppApiFp(this.configuration).authEstablecerPasswordTokenPost(token, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Request reset password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthEnAreaWebAppApi
     */
    public async authReestablecerPost(options?: AxiosRequestConfig) : Promise<any> {
        return AuthEnAreaWebAppApiFp(this.configuration).authReestablecerPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Login in WebApp area
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthEnAreaWebAppApi
     */
    public async loginPost(options?: AxiosRequestConfig) : Promise<any> {
        return AuthEnAreaWebAppApiFp(this.configuration).loginPost(options).then((request) => request(this.axios, this.basePath));
    }
}
